module.exports = __webpack_public_path__ + "img/solo.web@2x.9a31712b.png";